import { colors } from 'fitify-ui'
import styled from 'styled-components'

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const StyledList = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledMuscleItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
  gap: 12px;

  &:not(:last-child) {
    border-bottom: 1px solid ${colors.Gray200};
  }
`
